import * as actionTypes from './actionTypes';

/*------------------------------------------------------------------------------------------------*/
/* CampaignAnalytics Fetch Actions                                                                         */
/*------------------------------------------------------------------------------------------------*/

export const fetchStatsForTimerangeRequest = (requestData) => ({
  type: actionTypes.FETCH_STATS_FOR_TIMERANGE_REQUEST,
  requestData,
});

export const fetchStatsForTimerangeError = (error /*: string */) => ({
  type: actionTypes.FETCH_STATS_FOR_TIMERANGE_ERROR,
  error,
});

export const fetchStatsForTimerangeResponse = (response) => ({
  type: actionTypes.FETCH_STATS_FOR_TIMERANGE_RESPONSE,
  response,
});

export const fetchCampaignLinkStatsRequest = (requestData) => ({
  type: actionTypes.FETCH_CAMPAIGN_LINK_STATS_REQUEST,
  requestData,
});

export const fetchCampaignLinkStatsError = (error /*: string */) => ({
  type: actionTypes.FETCH_CAMPAIGN_LINK_STATS_ERROR,
  error,
});

export const fetchCampaignLinkStatsResponse = (response) => ({
  type: actionTypes.FETCH_CAMPAIGN_LINK_STATS_RESPONSE,
  response,
});

export const updateCampaignLabelsRequest = (requestData) => ({
  type: actionTypes.UPDATE_CAMPAIGN_ANALYTICS_LABELS_REQUEST,
  requestData,
});

export const updateCampaignLabelsSuccess = () => ({
  type: actionTypes.UPDATE_CAMPAIGN_ANALYTICS_LABELS_SUCCESS,
});

export const updateCampaignLabelsError = () => ({
  type: actionTypes.UPDATE_CAMPAIGN_ANALYTICS_LABELS_ERROR,
});

export const updateCampaignData = (campaign) => ({
  type: actionTypes.UPDATE_CAMPAIGN_DATA,
  campaign,
});

export const updateSelectedVariant = (variant) => ({
  type: actionTypes.UPDATE_SELECTED_VARIANT,
  variant,
});

export const updateAnalyticsMetricOptions = (options) => ({
  type: actionTypes.UPDATE_ANALYTICS_METRICS_OPTIONS,
  options,
});

export const fetchMetricsForCampaignRequest = (queryData) => {
  return {
    type: actionTypes.FETCH_METRICS_FOR_CAMPAIGN_REQUEST,
    queryData,
  };
};

export const fetchMetricsForCampaignResponse = (response) => {
  return {
    type: actionTypes.FETCH_METRICS_FOR_CAMPAIGN_RESPONSE,
    response,
  };
};

export const fetchMetricsForCampaignError = (error) => {
  return {
    type: actionTypes.FETCH_METRICS_FOR_CAMPAIGN_ERROR,
    error,
  };
};

export const fetchDestinationsRequest = () => {
  return {
    type: actionTypes.FETCH_DESTINATIONS_REQUEST,
  };
};

export const fetchDestinationsResponse = (response) => {
  return {
    type: actionTypes.FETCH_DESTINATIONS_RESPONSE,
    response,
  };
};

export const fetchDestinationsError = (error) => {
  return {
    type: actionTypes.FETCH_DESTINATIONS_ERROR,
    error,
  };
};
